module.exports = __webpack_public_path__ + "static/media/hiking.1d476762.svg";